module.exports = "https://web-assets.ifttt.com/packs/media/docs/actionsnotification-0b4f288f.gif";